module.exports = __webpack_public_path__ + "img/download-icon.2d0f99e7.svg";